
import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as firebase from 'firebase';
import './css/NavBar.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";

export function LoginModalView(props) {

    return (
        <div className="navLink">
            <a variant="base" onClick={props.handleClickOpen}>Login </a>

            <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Login</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {props.error && <i>Your login is invalid. Please try again.</i>}
                    </DialogContentText>
                    <form>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="email"
                            label="Email Address"
                            type="email"
                            fullWidth
                            onChange={props.inputEmail}
                            value={props.email}
                        />
                        <TextField
                            margin="dense"
                            id="password"
                            label="Password"
                            type="password"
                            fullWidth
                            onChange={props.inputPassword}
                            value={props.password}
                        />
                    </form>

                </DialogContent>
                <DialogActions>
                    <Button onClick={props.login} color="primary">
                        {!props.check && <Link to="/">Login</Link>}
                        {props.check && <Link to="/ProfileSettings">Login</Link>}
                    </Button>
                    <Button onClick={props.handleClose} color="primary">
                        Cancel
          </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}